export interface ProductRowOptions {
  quantity?: number;
  discountPct?: number;
}

/** Bedrag in centen na aantal en korting van de offerteregel. */
export const applyProductAdjustments = (cents: number, options: ProductRowOptions): number => {
  const withQuantity = cents * (options.quantity ?? 1);
  const discount = options.discountPct ? withQuantity * (options.discountPct / 100) : 0;
  return Math.round(withQuantity - discount);
};
